import type { GlobalFeatureFlags } from "../store/globalFeatureFlag";

type TenantListItem = {
  appId?: number;
  descriptionJson?: string;
};

type TenantOnboardingResponse = {
  data?: {
    list?: TenantListItem[];
  };
};

/**
 * Derives {@link GlobalFeatureFlags} from `apiGetTenant` (tenant onboarded modules / subscription).
 * Reads app 7 `descriptionJson.feature_flags` until a dedicated feature-flag API exists.
 */
export function parseTenantOnboardingResponseToGlobalFeatureFlags(
  res: TenantOnboardingResponse,
): Partial<GlobalFeatureFlags> {
  try {
    const descriptionJson = res.data?.list?.find?.((item: TenantListItem) => {
      return item.appId === 7 && item.descriptionJson;
    })?.descriptionJson;
    const tempJson: {
      feature_flags?: { flagKey: string; ext: string }[];
    } = JSON.parse(descriptionJson && descriptionJson !== "" ? descriptionJson : "{}");
    const enableServerPagination = tempJson?.feature_flags?.find(
      (i) => i.flagKey === "enableServerPagination",
    );
    if (
      enableServerPagination &&
      enableServerPagination.ext !== undefined &&
      enableServerPagination.ext !== ""
    ) {
      return { enableServerPagination: enableServerPagination.ext === "true" };
    }
    return { enableServerPagination: true };
  } catch {
    return { enableServerPagination: true };
  }
}
